import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { ScannedBarcodeData } from '../../common/types/models.ts';
import mutationHooks from '../../common/mutationHooks/index.ts';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  quarantineMedData:
    | (ScannedBarcodeData & { customerLocationId: number | string })
    | null;
  note: string;
  setNote: Dispatch<SetStateAction<string>>;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const QuarantineMedModal = ({
  isOpen,
  setIsOpen,
  quarantineMedData,
  note,
  setNote,
  onChange,
}: IProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const instanceRef = useRef<M.Modal | null>(null);

  const { mutate: quarantine } =
    mutationHooks.quarantine.useCreateOneQuarantine();

  const quarantineAndClose = () => {
    if (quarantineMedData) {
      quarantine({ ...quarantineMedData, note });
      setNote('');
    }

    instanceRef.current?.close();
  };

  useEffect(() => {
    if (!modalRef.current) return;

    instanceRef.current = M.Modal.init(modalRef.current, {
      onCloseEnd: () => setIsOpen(false),
      dismissible: false,
    });

    return () => {
      instanceRef.current?.destroy();
      instanceRef.current = null;
    };
  }, [setIsOpen]);

  useEffect(() => {
    const instance = instanceRef.current;
    if (!instance) return;

    if (isOpen) {
      instance.open();
    } else {
      instance.close();
    }
  }, [isOpen]);

  return (
    <div ref={modalRef} className="modal">
      <div className="modal-content">
        <div className="row">
          <h5 className="center">Med Not Found</h5>
          <div className="divider" />
        </div>

        <div
          className="row"
          style={{ textAlign: 'center', fontSize: '1.4rem' }}
        >
          The scanned med does not show as being connected to the given EPCIS
          document being received. If you would like to quarantine this item,
          click confirm. It will then need to be manually received. <br></br>
          <br></br>
        </div>

        <div className="row">
          <div className="input-field col s12 m12 l12">
            <textarea id="note" name="note" value={note} onChange={onChange} />
            <label htmlFor="note">Note</label>
          </div>
        </div>

        <div className="row">
          <button
            className="btn-small green waves-effect waves-dark col s3 m4"
            onClick={() => {
              quarantineAndClose();
            }}
          >
            Confirm
          </button>
          <button
            className="btn-small red waves-effect waves-dark col s3 offset-m4 m4 "
            onClick={() => instanceRef.current?.close()}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuarantineMedModal;
